import { ReactNode } from "react";
import { X } from "lucide-react";

interface ModalProps {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
}

export default function Modal({ open, onClose, children }: ModalProps) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* overlay */}
      <div
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* modal box with scrolling */}
      <div className="relative bg-musicBlack text-musicWhite w-full max-w-lg max-h-[90vh] rounded-lg shadow-lg overflow-hidden">
        <button
          className="absolute top-3 right-3 text-musicGrey hover:text-musicRed z-10"
          onClick={onClose}
        >
          <X size={20} />
        </button>
        <div className="overflow-y-auto max-h-[90vh] p-8">
          {children}
        </div>
      </div>
    </div>
  );
}
